module.exports = __webpack_public_path__ + "img/20180815_151538_169.a0277806.jpg";